function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var STORAGE_KEY = '__lookupFavItem';
var STORAGE_VERSION = 4;
var MIN10 = 1000 * 60 * 10;
var isBrowser$1 = typeof window !== 'undefined';
function mkItemFolder(itemType, itemId, folderIds) {
  return {
    itemType,
    itemId,
    folderIds
  };
}
function mkKey(itemType, itemId) {
  return "".concat(itemType, ":").concat(itemId);
}
// this matches the data shape of the data we get from the servers minimal-v2-endpoint,
/*
{
    "items": [
        { "itemType": "Ad", "itemId": 456789, "folderIds": [ 1 ] },
        { "itemType": "Hotel", "itemId": 666, "folderIds": [ 1 ] },
        { "itemType": "Hotel", "itemId": 456789, "folderIds": [ 1 ] }
    ]
}
 */
class StorageAtom {
  constructor(ttl, version, items, dataFromServer, userId) {
    _defineProperty(this, "ttl", void 0);
    _defineProperty(this, "version", void 0);
    _defineProperty(this, "userId", void 0);
    _defineProperty(this, "items", void 0);
    _defineProperty(this, "dataFromServer", void 0);
    this.ttl = ttl;
    this.version = version;
    this.userId = userId;
    this.items = items;
    this.dataFromServer = dataFromServer;
  }
}
function replaceItems(state, newItems) {
  return new StorageAtom(state.ttl, state.version, newItems, state.dataFromServer, state.userId);
}
class FavoriteStorage {
  constructor(onItemUpdate, userId, storage, ttl, key, getNow) {
    _defineProperty(this, "userId", void 0);
    _defineProperty(this, "storage", void 0);
    _defineProperty(this, "ttl", void 0);
    _defineProperty(this, "key", void 0);
    _defineProperty(this, "getNow", void 0);
    _defineProperty(this, "storageHandler", void 0);
    this.userId = userId;
    this.storage = storage || (isBrowser$1 ? window.localStorage : null);
    this.ttl = ttl || MIN10;
    this.key = key || STORAGE_KEY;
    this.getNow = getNow || (() => Date.now());
    this.key = STORAGE_KEY;
    this.storageHandler = event => {
      try {
        var _newValue$userId, _this$userId;
        if (event.key !== this.key) {
          return;
        }
        if (event.oldValue === event.newValue) {
          return;
        }
        if (!event.newValue) {
          return;
        }
        var newValue = JSON.parse(event.newValue || '');
        if (((_newValue$userId = newValue.userId) === null || _newValue$userId === void 0 ? void 0 : _newValue$userId.toString()) !== ((_this$userId = this.userId) === null || _this$userId === void 0 ? void 0 : _this$userId.toString())) {
          return;
        }
        if (event.oldValue && newValue.items) {
          var oldValue = JSON.parse(event.oldValue);
          newValue.items.forEach(newKey => {
            var notPresentInOldValue = oldValue.items != null && !oldValue.items.find(i => i.itemType === newKey.itemType && i.itemId === newKey.itemId);
            if (notPresentInOldValue) {
              var newItemFolder = newValue.items.find(i => i.itemType === newKey.itemType && i.itemId === newKey.itemId) || mkItemFolder(newKey.itemType, newKey.itemId, []);
              onItemUpdate(mkKey(newKey.itemType, newKey.itemId), newItemFolder);
            }
          });
        } else {
          newValue.items.forEach(newKey => {
            var newItemFolder = newValue.items.find(i => i.itemType === newKey.itemType && i.itemId === newKey.itemId) || mkItemFolder(newKey.itemType, newKey.itemId, []);
            onItemUpdate(mkKey(newKey.itemType, newKey.itemId), newItemFolder);
          });
        }
      } catch (e) {
        /* Ignore all errors */
      }
    };
    if (isBrowser$1) {
      window.addEventListener('storage', this.storageHandler);
    }
  }
  // mainly used for storybook
  unbind() {
    window.removeEventListener('storage', this.storageHandler);
  }
  createEmptyState() {
    var _this$userId2;
    return new StorageAtom(this.getNow() + this.ttl, STORAGE_VERSION, [], false, (_this$userId2 = this.userId) === null || _this$userId2 === void 0 ? void 0 : _this$userId2.toString());
  }
  resetState() {
    var _this$storage;
    var newState = this.createEmptyState();
    (_this$storage = this.storage) === null || _this$storage === void 0 ? void 0 : _this$storage.setItem(this.key, JSON.stringify(newState));
    return newState;
  }
  isValid(state) {
    var _state$userId, _this$userId3;
    if (!state || state.version !== STORAGE_VERSION || state.ttl <= this.getNow() || ((_state$userId = state.userId) === null || _state$userId === void 0 ? void 0 : _state$userId.toString()) !== ((_this$userId3 = this.userId) === null || _this$userId3 === void 0 ? void 0 : _this$userId3.toString())) {
      // Clearing potential old state (could be different user)
      return this.resetState();
    }
    return state;
  }
  getState() {
    try {
      var _this$storage2;
      var state = this.isValid(JSON.parse(((_this$storage2 = this.storage) === null || _this$storage2 === void 0 ? void 0 : _this$storage2.getItem(this.key)) || ''));
      if (state) {
        return state;
      }
    } catch (e) {
      // invalid (unparsable) state: reset
      return this.resetState();
    }
    return this.createEmptyState();
  }
  isEmpty() {
    return !this.getState().dataFromServer;
  }
  // gets folderid[]
  getFolderIds(itemType, itemId) {
    var pred = i => i.itemType === itemType && i.itemId === itemId;
    var state = this.getState();
    if (state && state.items) {
      if (Array.isArray(state.items)) {
        var found = state.items.find(pred);
        if (found) {
          return found.folderIds;
        }
      } else {
        return [];
      }
      return [];
    }
    return [];
  }
  // used for manipulating local state
  addToFolder(itemType, itemId, folderId) {
    var entryExists = false;
    function mapper(item) {
      if (item.itemType === itemType && item.itemId === itemId) {
        entryExists = true; // we'll push the new entry onto a new item
        item.folderIds.push(folderId);
        return item;
      }
      return item;
    }
    try {
      var _this$storage3;
      var state = this.getState();
      if (state && state.items && state.items) {
        var newItems = state.items.map(mapper);
        state = replaceItems(state, newItems);
      }
      if (!entryExists) {
        state.items.push(mkItemFolder(itemType, itemId, [folderId]));
      }
      (_this$storage3 = this.storage) === null || _this$storage3 === void 0 ? void 0 : _this$storage3.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  }
  // used for manipulating local state
  removeFromFolder(itemType, itemId, folderId) {
    function filterFolder(item) {
      if (item.itemType === itemType && item.itemId === itemId) {
        var newFolders = item.folderIds.filter(aFolderId => aFolderId !== folderId);
        return mkItemFolder(item.itemType, item.itemId, newFolders);
      }
      return item;
    }
    try {
      var _this$storage4;
      var state = this.getState();
      if (state && state.items) {
        var newItems = state.items.map(filterFolder);
        state = replaceItems(state, newItems);
      }
      (_this$storage4 = this.storage) === null || _this$storage4 === void 0 ? void 0 : _this$storage4.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  }
  // used for manipulating local state
  removeFolder(folderId) {
    function removeFolder(item) {
      var newItems = item.folderIds.filter(aFolderId => aFolderId !== folderId);
      return mkItemFolder(item.itemType, item.itemId, newItems);
    }
    try {
      var _this$storage5;
      var state = this.getState();
      if (state && state.items) {
        var removed = state.items.map(removeFolder);
        var newItems = removed.filter(item => item.folderIds.length > 0);
        state = replaceItems(state, newItems);
      }
      (_this$storage5 = this.storage) === null || _this$storage5 === void 0 ? void 0 : _this$storage5.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  }
  // used to re-set state
  setItems(items) {
    try {
      var _this$storage6;
      var state = this.createEmptyState();
      state.items = items;
      state.dataFromServer = true;
      (_this$storage6 = this.storage) === null || _this$storage6 === void 0 ? void 0 : _this$storage6.setItem(this.key, JSON.stringify(state));
      return true;
    } catch (e) {
      return false;
    }
  }
}

class Fetcher {
  constructor(baseUri, fetch) {
    _defineProperty(this, "baseUri", void 0);
    _defineProperty(this, "fetch", void 0);
    this.baseUri = baseUri;
    this.fetch = fetch || Fetcher.fetch;
    this.fetchFolders = this.fetchFolders.bind(this);
    this.fetchMinimalFavoriteMap = this.fetchMinimalFavoriteMap.bind(this);
    this.addToFolder = this.addToFolder.bind(this);
    this.removeFromFolder = this.removeFromFolder.bind(this);
    this.createFolder = this.createFolder.bind(this);
    this.deleteFolder = this.deleteFolder.bind(this);
    this.fetchNumFavs = this.fetchNumFavs.bind(this);
  }
  static fetch(url, options) {
    return window.fetch(url, options);
  }
  static getCredentialsHeader() {
    var {
      host
    } = window.location;
    if (host.includes('local.finn.no')) {
      return 'include';
    }
    return 'same-origin';
  }
  fetchMinimalFavoriteMap() {
    return this.fetch("".concat(this.baseUri, "/minimal"), {
      credentials: Fetcher.getCredentialsHeader()
    });
  }
  addToFolder(itemType, itemId, folderId) {
    return this.fetch("".concat(this.baseUri, "/").concat(folderId, "/").concat(itemType, "/").concat(itemId), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'PUT'
    });
  }
  removeFromFolder(itemType, itemId, folderId) {
    return this.fetch("".concat(this.baseUri, "/").concat(folderId, "/").concat(itemType, "/").concat(itemId), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'DELETE'
    });
  }
  fetchFolders() {
    return this.fetch(this.baseUri, {
      credentials: Fetcher.getCredentialsHeader()
    });
  }
  createFolder(name) {
    return this.fetch("".concat(this.baseUri), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name
      })
    });
  }
  deleteFolder(folderId) {
    return this.fetch("".concat(this.baseUri, "/").concat(folderId), {
      credentials: Fetcher.getCredentialsHeader(),
      method: 'DELETE'
    });
  }
  fetchNumFavs(itemType, itemId) {
    return this.fetch("".concat(this.baseUri, "/").concat(itemType, "/").concat(itemId, "/counter"), {
      credentials: Fetcher.getCredentialsHeader()
    });
  }
}

var isBrowser = typeof window !== 'undefined';
var safeWindow = isBrowser ? window : {};
class ControllablePromise {
  constructor() {
    _defineProperty(this, "promise", void 0);
    _defineProperty(this, "resolve", void 0);
    _defineProperty(this, "reject", void 0);
    _defineProperty(this, "timer", void 0);
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}
class GlobalDelayedCollector {
  constructor(namespace, handler, timeout) {
    _defineProperty(this, "namespace", void 0);
    _defineProperty(this, "handler", void 0);
    _defineProperty(this, "timeout", void 0);
    this.namespace = namespace;
    this.handler = handler;
    this.timeout = timeout || 15;
  }
  getGlobalPromise() {
    safeWindow[this.namespace] = safeWindow[this.namespace] || new ControllablePromise();
    return safeWindow[this.namespace];
  }
  resetState() {
    delete safeWindow[this.namespace];
  }
  collectAndHandle() {
    var state = this.getGlobalPromise();
    clearTimeout(state.timer);
    state.timer = window.setTimeout(() => {
      this.resetState();
      this.handler().then(state.resolve).catch(state.reject);
    }, this.timeout);
    return state.promise;
  }
}
class GlobalBus {
  constructor(ns) {
    _defineProperty(this, "key", void 0);
    this.key = "".concat(ns, "__queue");
    safeWindow[this.key] = safeWindow[this.key] || [];
  }
  reset() {
    safeWindow[this.key] = [];
  }
  getQueue() {
    return safeWindow[this.key];
  }
  // key is ItemType:ItemId (like Ad:1234)
  subscribe(key, func) {
    this.getQueue().push([key, func]);
  }
  unsubscribe(key, func) {
    safeWindow[this.key] = this.getQueue().filter(_ref => {
      var [_key, _func] = _ref;
      return !(_key === key && _func === func);
    });
  }
  // key is ItemType:ItemId (like Ad:1234)
  matches(key) {
    return this.getQueue().filter(_ref2 => {
      var [_key] = _ref2;
      return _key.toString() === key.toString();
    }).map(_ref3 => {
      var [, func] = _ref3;
      return func;
    });
  }
  // key is ItemType:ItemId (like Ad:1234)
  emit(key, state) {
    this.matches(key).forEach(func => func(state));
  }
}
class FavoriteBrowserCache {
  constructor(userId, namespace, storage, ttl, fetch, baseUri) {
    _defineProperty(this, "namespace", void 0);
    _defineProperty(this, "fetcher", void 0);
    _defineProperty(this, "toggledStateBus", void 0);
    _defineProperty(this, "recountStateBus", void 0);
    _defineProperty(this, "favStorage", void 0);
    _defineProperty(this, "getItemCollector", void 0);
    this.namespace = namespace || '__lookupFavItem';
    this.toggledStateBus = new GlobalBus("".concat(this.namespace, "__toggled"));
    this.recountStateBus = new GlobalBus("".concat(this.namespace, "__recount"));
    this.favStorage = new FavoriteStorage((key, data) => {
      this.toggledStateBus.emit(key, !!data);
    }, userId !== null && userId !== void 0 ? userId : undefined, storage, ttl);
    this.fetcher = new Fetcher(baseUri || FavoriteBrowserCache.getEnvBasedUrl(), fetch);
    this.getItemCollector = new GlobalDelayedCollector(this.namespace, () => this.fetcher.fetchMinimalFavoriteMap().then(FavoriteBrowserCache.validateResponseOK).then(res => res.json()).then(j => {
      this.favStorage.setItems(j.items);
    }).catch(() => {
      /* Ignore all errors */
    }));
    this.fetchFolders = this.fetchFolders.bind(this);
    this.fetchFoldersForItem = this.fetchFoldersForItem.bind(this);
    this.addToFolder = this.addToFolder.bind(this);
    this.removeFromFolder = this.removeFromFolder.bind(this);
    this.createFolder = this.createFolder.bind(this);
    this.deleteFolder = this.deleteFolder.bind(this);
  }
  unmount() {
    this.toggledStateBus.reset();
    this.recountStateBus.reset();
    this.favStorage.unbind();
  }
  static getEnvBasedUrl() {
    var {
      host
    } = isBrowser ? window.location : {
      host: ''
    };
    if (host.includes('local.finn.no')) {
      return 'http://local.finn.no:3050/favorittliste/podium-resource/favorittlistePodlet/favorite-api';
    }
    if (host.includes('dev.finn.no')) {
      return 'https://dev.finn.no/favorittliste/podium-resource/favorittlistePodlet/favorite-api';
    }
    return 'https://www.finn.no/favorittliste/podium-resource/favorittlistePodlet/favorite-api';
  }
  getFavoriteState(itemType, itemId, toggledFunc) {
    var itemIdNumber = Number(itemId);
    this.toggledStateBus.subscribe(mkKey(itemType, itemIdNumber), toggledFunc);
    this.isItemFavorited(itemType, itemIdNumber);
    return () => {
      this.toggledStateBus.unsubscribe(mkKey(itemType, itemIdNumber), toggledFunc);
    };
  }
  subscribeToRecount(itemType, itemId, recountFunc) {
    var itemIdNumber = Number(itemId);
    this.recountStateBus.subscribe(mkKey(itemType, itemIdNumber), recountFunc);
    this.fetchAndEmitNumFavs(itemType, itemIdNumber);
    return () => {
      this.recountStateBus.unsubscribe(mkKey(itemType, itemIdNumber), recountFunc);
    };
  }
  isItemFavorited(itemType, itemId) {
    var itemIdNumber = Number(itemId);
    if (this.favStorage.isEmpty()) {
      // This is the place that the storage gets filled up initially
      return this.getItemCollector.collectAndHandle().then(() => new Promise(resolve => {
        setTimeout(() => {
          var favs = this.favStorage.getFolderIds(itemType, itemIdNumber);
          this.toggledStateBus.emit(mkKey(itemType, itemIdNumber), favs.length > 0);
          if (favs.length > 0) {
            return resolve(true);
          }
          return resolve(false);
        }, 0);
      }));
    }
    var favs = this.favStorage.getFolderIds(itemType, itemIdNumber); // getFromId(id);
    this.toggledStateBus.emit(mkKey(itemType, itemIdNumber), favs.length > 0);
    if (favs.length > 0) {
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  addToFolder(itemType, itemId, folderId) {
    var itemIdNumber = Number(itemId);
    var folderIdNumber = Number(folderId);
    return this.fetcher.addToFolder(itemType, itemIdNumber, folderIdNumber).then(r => {
      this.toggledStateBus.matches(mkKey(itemType, itemIdNumber)).forEach(cb => cb(true));
      this.favStorage.addToFolder(itemType, itemIdNumber, folderIdNumber);
      this.fetchAndEmitNumFavs(itemType, itemIdNumber);
      return r;
    });
  }
  removeFromFolder(itemType, itemId, folderId) {
    var itemIdNumber = Number(itemId);
    var folderIdNumber = Number(folderId);
    return this.fetcher.removeFromFolder(itemType, itemIdNumber, folderIdNumber).then(r => {
      this.favStorage.removeFromFolder(itemType, itemIdNumber, folderIdNumber);
      this.uncheckHeartIfRemovedFromAllFolders(itemType, itemIdNumber);
      this.fetchAndEmitNumFavs(itemType, itemIdNumber);
      return r;
    });
  }
  fetchFolders() {
    // [folderid]: {name, image}
    return this.fetcher.fetchFolders();
  }
  fetchFoldersForItem(itemType, itemId) {
    var itemIdNumber = Number(itemId);
    return Promise.resolve(mkItemFolder(itemType, itemIdNumber, this.favStorage.getFolderIds(itemType, itemIdNumber)));
  }
  createFolder(name) {
    return this.fetcher.createFolder(name);
  }
  deleteFolder(folderId) {
    var folderIdNumber = Number(folderId);
    return this.fetcher.deleteFolder(folderIdNumber).then(r => {
      this.favStorage.removeFolder(folderIdNumber);
      return r;
    });
  }
  static validateResponseOK(response) {
    if (response.ok) {
      return Promise.resolve(response);
    }
    return Promise.reject(response);
  }
  uncheckHeartIfRemovedFromAllFolders(itemType, itemIdNumber) {
    var folders = this.favStorage.getFolderIds(itemType, itemIdNumber);
    if (folders && folders.length < 1) {
      this.toggledStateBus.matches(mkKey(itemType, itemIdNumber)).forEach(cb => cb(false));
    }
  }
  fetchAndEmitNumFavs(itemType, itemId) {
    this.fetchNumFavs(itemType, itemId).then(FavoriteBrowserCache.validateResponseOK).then(res => this.emitFavCounter(res, itemType, itemId)).catch(res => this.emitZeroCountIfNotFound(res, itemType, itemId)).catch(() => {
      /* Ignore all errors */
    });
  }
  fetchNumFavs(itemType, itemId) {
    return this.fetcher.fetchNumFavs(itemType, itemId);
  }
  emitFavCounter(res, itemType, itemId) {
    return res.json().then(c => this.recountStateBus.emit(mkKey(itemType, itemId), c.counter)).catch(() => Promise.reject(res));
  }
  emitZeroCountIfNotFound(res, itemType, itemId) {
    if (res.status === 404) {
      this.recountStateBus.emit(mkKey(itemType, itemId), 0);
      return Promise.resolve(res);
    }
    return Promise.reject(res);
  }
}

export { FavoriteBrowserCache };
//# sourceMappingURL=index.es.js.map
